export enum EnumMotivoCancelamento {
    TrocaParaSaurus,
    TrocaOutroSistema,
    TrocaCNPJ,
    EstabelecimentoFechou,
    ClienteInadimplente,
    FaltaRecursoSaurus,
    SemContatoCliente,
    Outros = 99,
}